import { inputTextLimit } from '../../../helpers/fieldRestriction';
import messages from '../../../locale/jsonMessages';

const validate = (values, props) => {
  const errors = {};
  const activeLanguageCodes = props?.activeLanguageCodes || [];

  if (!values.dataList || !values.dataList.length) {
    errors.dataList = { _error: messages.required };
  } else {
    const documentArrayErrors = [];

    values.dataList.forEach((document, index) => {
      const documentErrors = {};

      if (!document || !document.imageName) {
        documentErrors.imageName = messages.required;
      }

      if (document?.dynamicWhyHost && document.dynamicWhyHost.length > 0) {
        const dynamicErrors = document.dynamicWhyHost.map(item => {
          const itemErrors = {};

          const isLanguageInactive = item?.language && activeLanguageCodes.length > 0
            && !activeLanguageCodes.includes(item.language);

          if (!item?.language || item?.language.toString().trim() === '' || isLanguageInactive) {
            itemErrors.language = messages.required;
          }

          if (!item?.title) {
            itemErrors.title = messages.required;
          } else if (item.title.trim() === '') {
            itemErrors.title = messages.required;
          } else if (item.title.length > inputTextLimit) {
            itemErrors.title = messages.inputTextLimitError;
          }

          if (!item?.buttonLabel) {
            itemErrors.buttonLabel = messages.required;
          } else if (item.buttonLabel.trim() === '') {
            itemErrors.buttonLabel = messages.required;
          } else if (item.buttonLabel.length > inputTextLimit) {
            itemErrors.buttonLabel = messages.inputTextLimitError;
          }

          return itemErrors;
        });

        if (dynamicErrors.some(e => Object.keys(e).length > 0)) {
          documentErrors.dynamicWhyHost = dynamicErrors;
        }
      }

      if (Object.keys(documentErrors).length > 0) {
        documentArrayErrors[index] = documentErrors;
      }
    });

    if (documentArrayErrors.length) {
      errors.dataList = documentArrayErrors;
    }
  }

  return errors;
};

export default validate;